import React, { useState, useRef, useEffect } from 'react';
import { FaHiking, FaWater, FaParachuteBox, FaCampground } from 'react-icons/fa';
import { GiDeer } from 'react-icons/gi';
import '../Serve/Serve.css';

const tourTypes = [
  { id: 1, title: 'Adventure Trek', icon: <FaHiking />, description: 'Explore thrilling hiking adventures around the world.' },
  { id: 2, title: 'Windsurfing Fun', icon: <FaWater />, description: 'Ride the waves and enjoy exciting windsurfing experiences.' },
  { id: 3, title: 'Paragliding High', icon: <FaParachuteBox />, description: 'Soar the skies with our guided paragliding tours.' },
  { id: 4, title: 'Wildlife Safari', icon: <GiDeer />, description: 'Discover nature and wildlife in their natural habitat.' },
  { id: 5, title: 'Hang Gliding Camp', icon: <FaCampground />, description: 'Fly freely and camp under the stars with us.' },
];

const Serve = () => {
  const [activeId, setActiveId] = useState(2);
  const containerRef = useRef(null);
  const indexRef = useRef(1); // Start from index 1 for Windsurfing Fun

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % tourTypes.length;
      setActiveId(tourTypes[indexRef.current].id);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    const activeCard = container?.querySelector('.card-s.active');
    if (container && activeCard) {
      const containerRect = container.getBoundingClientRect();
      const cardRect = activeCard.getBoundingClientRect();
      const offset = cardRect.left - containerRect.left - container.clientWidth / 2 + cardRect.width / 2;
      container.scrollBy({ left: offset, behavior: 'smooth' });
    }
  }, [activeId]);

  return (
    <section className="serve-section-s">
      <p className="serve-label-s">SERVICES</p>
      <h1 className="serve-heading-s">
        Explore Our Tour Options and <br /> Start Your Journey
      </h1>

      <div className="cards-container-s" ref={containerRef}>
        {tourTypes.map((type, index) => (
          <div
            key={type.id}
            className={`card-s ${activeId === type.id ? 'active' : ''}`}
            onClick={() => {
              setActiveId(type.id);
              indexRef.current = index; // Keep index in sync if clicked
            }}
          >
            <div className="card-number-s">{String(index + 1).padStart(2, '0')}</div>
            <div className="card-icon-s">{type.icon}</div>
            <h3>{type.title}</h3>
            <p>{type.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Serve;
